export function loadGoogleMapsPlaces() {
  const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) return resolve(window.google);

    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    );
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.google));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}